/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DataTypeEnums {
    OBJECT = 0,
    NULLABLE_OBJECT = 1,
    STRING = 2,
    NULLABLE_STRING = 3,
    BOOLEAN = 4,
    NULLABLE_BOOLEAN = 5,
    INT = 6,
    NULLABLE_INT = 7,
    LONG = 8,
    NULLABLE_LONG = 9,
    DECIMAL = 10,
    NULLABLE_DECIMAL = 11,
    DOUBLE = 12,
    NULLABLE_DOUBLE = 13,
    DATETIME = 14,
    NULLABLE_DATETIME = 15,
    DATETIME2 = 16,
    NULLABLE_DATETIME2 = 17,
    CHAR = 18,
    NULLABLE_CHAR = 19,
    TIMESPAN = 20,
    NULLABLE_TIMESPAN = 21,
    FLOAT = 22,
    NULLABLE_FLOAT = 23,
    BYTE = 24,
    NULLABLE_BYTE = 25,
    SHORT = 26,
    NULLABLE_SHORT = 27,
    DYNAMIC = 28,
    NULLABLE_DYNAMIC = 29,
    DATE = 30,
    NULLABLE_DATE = 31,
}
